import Vue from 'vue'
import VueRouter from 'vue-router'
import auth from '@/services/AuthService'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: () => {
      const userRole = auth.getUserRole ? auth.getUserRole() : 0;
      if (userRole === 5) return '/customer-service/tickets';
      if (userRole === 4) return '/operations';
      if (userRole === 3) return '/routes';
      return '/dashboard';
    },
  },
  {
    path: '/customer-service',
    redirect: '/customer-service/tickets',
  },
  {
    path: '/customer-service/customers',
    name: 'customer-service-customers',
    component: () => import('@/views/customer-service/customers/index.vue'),
  },
  {
    path: '/customer-service/customers/:id',
    name: 'customer-service-customer-view',
    component: () => import('@/views/customer-service/customers/view.vue'),
  },
  {
    path: '/customer-service/bookings',
    name: 'customer-service-bookings',
    component: () => import('@/views/customer-service/bookings/index.vue'),
  },
  {
    path: '/customer-service/bookings/:id',
    name: 'customer-service-booking-view',
    component: () => import('@/views/customer-service/bookings/view.vue'),
  },
  {
    path: '/customer-service/refunds',
    name: 'customer-service-refunds',
    component: () => import('@/views/customer-service/refunds/index.vue'),
  },
  {
    path: '/customer-service/refunds/:id',
    name: 'customer-service-refund-view',
    component: () => import('@/views/customer-service/refunds/view.vue'),
  },
  {
    path: '/customer-service/tickets',
    name: 'customer-service-tickets',
    component: () => import('@/views/customer-service/tickets/index.vue'),
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('@/views/dashboard/Dashboard.vue'),
  },
  //////////////////////////users////////////////////////////////
  //admins
  {
    path: '/admin',
    name: 'admin',
    component: () => import('@/views/users/index.vue'),
  },
  //customers
  {
    path: '/customers',
    name: 'customers',
    component: () => import('@/views/users/index.vue'),
  },
  //drivers
  {
    path: '/drivers',
    name: 'drivers',
    component: () => import('@/views/users/index.vue'),
  },
  {
    path: '/users/view/user=:user_id',
    name: 'view-user',
    component: () => import('@/views/users/view-user.vue'),
  },
  {
    path: '/users/view',
    name: 'view-user-query',
    component: () => import('@/views/users/view-user.vue'),
  },
  {
    path: '/users/edit/user=:user_id',
    name: 'edit-user',
    component: () => import('@/views/users/edit-user.vue'),
  },
    //////////////////////////buses////////////////////////////////
    {
      path: '/buses',
      name: 'buses',
      component: () => import('@/views/system-setup/buses/index.vue'),
    },
    //////////////////////////buses////////////////////////////////
    {
        path: '/coupons',
        name: 'coupons',
        component: () => import('@/views/coupons/index.vue'),
        },
  //////////////////////////routes////////////////////////////////
  {
    path: '/routes',
    alias: '/system-setup/routes',
    name: 'routes',
    component: () => import('@/views/system-setup/routes/index.vue'),
  },
  {
    path: '/routes/create',
    name: 'create-route-direct',
    component: () => import('@/views/system-setup/routes/create-edit.vue'),
  },
  {
    path: '/routes/create/route=:route_name',
    name: 'create-route',
    component: () => import('@/views/system-setup/routes/create-edit.vue'),
  },
  {
    path: '/routes/edit/route=:route_id&route_name=:new_route_name',
    name: 'edit-route',
    component: () => import('@/views/system-setup/routes/create-edit.vue'),
  },
  {
    path: '/routes/view/route=:route_id',
    name: 'view-route',
    component: () => import('@/views/system-setup/routes/view.vue'),
  },
  //////////////////////////stops////////////////////////////////
  {
    path: '/stops',
    name: 'stops',
    component: () => import('@/views/system-setup/stops/index.vue'),
  },
  {
    path: '/stops/view/stop=:stop_id',
    name: 'view-stop',
    component: () => import('@/views/system-setup/stops/view.vue'),
  },
  {
    path: '/stops/create',
    name: 'create-stop',
    component: () => import('@/views/system-setup/stops/create-edit.vue'),
  },
  {
    path: '/stops/edit/stop=:stop_id',
    name: 'edit-stop',
    component: () => import('@/views/system-setup/stops/create-edit.vue'),
  },
  {
    path: '/trips',
    name: 'trips',
    component: () => import('@/views/trips/index.vue'),
  },
  {
    path: '/trips/route/:route_id',
    name: 'route-making-route-trips',
    component: () => import('@/views/trips/RouteMakingRouteTrips.vue'),
  },
  //////////////////////////trip-groups////////////////////////////////
  {
    path: '/trip-groups',
    name: 'trip-groups',
    component: () => import('@/views/trip-groups/index.vue'),
  },
  {
    path: '/trip-groups/create',
    name: 'create-trip-group',
    component: () => import('@/views/trip-groups/create-edit.vue'),
  },
  {
    path: '/trip-groups/:id/edit',
    name: 'edit-trip-group',
    component: () => import('@/views/trip-groups/create-edit.vue'),
  },
  {
    path: '/trip-groups/:id',
    name: 'view-trip-group',
    component: () => import('@/views/trip-groups/details.vue'),
  },
  //////////////////////////operations////////////////////////////////
  {
    path: '/operations',
    name: 'operations-home',
    component: () => import('@/views/operations/home.vue'),
  },
  {
    path: '/operations/home',
    redirect: '/operations',
  },
  {
    path: '/operations/drivers',
    name: 'operations-drivers',
    component: () => import('@/views/operations/drivers.vue'),
  },
  {
    path: '/operations/vehicles',
    name: 'operations-vehicles',
    component: () => import('@/views/operations/vehicles.vue'),
  },
  {
    path: '/operations/routes',
    name: 'operations-routes',
    component: () => import('@/views/operations/routes.vue'),
  },
  {
    path: '/operations/trips',
    name: 'operations-trips',
    component: () => import('@/views/operations/trips.vue'),
  },
  {
    path: '/operations/live-tracking',
    name: 'operations-live-tracking',
    component: () => import('@/views/operations/live-tracking.vue'),
  },
  {
    path: '/operations/support',
    name: 'operations-support',
    component: () => import('@/views/operations/support/index.vue'),
  },
  {
    path: '/operations/routes/groups/:groupId',
    name: 'operations-group-routes',
    component: () => import('@/views/operations/group-routes.vue'),
  },
  //driver-conflicts
  {
    path: '/driver-conflicts',
    name: 'driver-conflicts',
    component: () => import('@/views/trips/driver-conflicts/index.vue'),
  },
  //////////////////////////customers////////////////////////////////
  {
    path: '/trips/create',
    name: 'create-trip',
    component: () => import('@/views/trips/create-edit.vue'),
  },
  {
    path: '/trips/edit/trip=:trip_id&action=:action',
    name: 'edit-trip',
    component: () => import('@/views/trips/create-edit.vue'),
  },
  {
    path: '/trips/view-trip/trip=:trip_id',
    name: 'view-trip',
    component: () => import('@/views/trips/view-trip.vue'),
  },
  {
    path: '/trips/view-calendar/trip=:trip_id&suspension=:suspension_id',
    name: 'view-calendar',
    component: () => import('@/views/trips/calendar/view-calendar.vue'),
  },
  //////////////////////////reservations////////////////////////////////
  {
    path: '/reservations',
    name: 'reservations',
    component: () => import('@/views/reservations/index.vue'),
  },
  {
    path: '/complaints',
    name: 'complaints',
    component: () => import('@/views/complaints/index.vue'),
  },
  {
    path: '/driver-emergency-requests',
    name: 'driver-emergency-requests',
    component: () => import('@/views/driver-emergency-requests/index.vue'),
  },
  //////////////////////////planned-trips////////////////////////////////
  {
    path: '/planned-trips',
    name: 'planned-trips',
    component: () => import('@/views/planned-trips/index.vue'),
  },
  //////////////////////////subscriptions////////////////////////////////
  {
    path: '/subscription-plans',
    name: 'subscription-plans',
    component: () => import('@/views/subscriptions/plans.vue'),
  },
  {
    path: '/route-subscription-pass-plans',
    name: 'route-subscription-pass-plans',
    component: () => import('@/views/subscriptions/route-pass-plans.vue'),
  },
  {
    path: '/route-subscription-passes',
    name: 'route-subscription-passes',
    component: () => import('@/views/subscriptions/route-passes.vue'),
  },
  {
    path: '/trip-subscriptions',
    name: 'trip-subscriptions',
    component: () => import('@/views/subscriptions/index.vue'),
  },
  //////////////////////////Payments///////////////////////////////////
  {
    path: '/upcoming-payments',
    name: 'upcoming-payments',
    component: () => import('@/views/payments/upcoming-payments/index.vue'),
  },
  {
    path: '/upcoming-payments/view-payment/user=:user_id',
    name: 'view-upcoming-payment',
    component: () => import('@/views/payments/upcoming-payments/view-payment.vue'),
  },
  {
    path: '/redemptions',
    name: 'redemptions',
    component: () => import('@/views/payments/redemptions/index.vue'),
  },
  {
    path: '/driver-earnings-report',
    name: 'driver-earnings-report',
    component: () => import('@/views/payments/driver-earnings-report.vue'),
  },
  //////////////////////////private-car-bookings/////////////////////////
  {
    path: '/private-car-bookings/types',
    name: 'car-types',
    component: () => import('@/views/private-car-booking/types.vue'),
  },
  {
    path: '/private-car-bookings/cars',
    name: 'cars',
    component: () => import('@/views/private-car-booking/cars.vue'),
  },
  {
    path: '/private-car-bookings/requests',
    name: 'private-car-requests',
    component: () => import('@/views/private-car-booking/requests.vue'),
  },
  //////////////////////////driver-services///////////////////////////////
  {
    path: '/driver-services/towing',
    name: 'towing-services',
    component: () => import('@/views/driver-services/towing.vue'),
  },
  {
    path: '/driver-services/repair-centers',
    name: 'repair-centers',
    component: () => import('@/views/driver-services/repair-centers.vue'),
  },
  {
    path: '/driver-services/faqs',
    name: 'driver-faqs',
    component: () => import('@/views/driver-services/faqs.vue'),
  },
  //////////////////////////live-tracking////////////////////////////////
  {
    path: "/live-tracking",
    name: "live-tracking",
    component: () => import("@/views/live-tracking/index.vue"),
  },
  //////////////////////////settings///////////////////////////////////
  {
    path: '/settings',
    name: 'settings',
    component: () => import('@/views/settings/index.vue'),
  },
  {
    path: '/driver-wallet-settings',
    name: 'driver-wallet-settings',
    component: () => import('@/views/settings/driver-wallet.vue'),
  },
  //////////////////////////activation///////////////////////////////////
  {
    path: '/activate-account',
    alias: '/activation',
    name: 'activate-account',
    component: () => import('@/views/activation/index.vue'),
  },
  //privacy-policy
  {
    path: '/privacy-policy',
    name: 'privacy-policy',
    component: () => import('@/views/settings/privacy-policy.vue'),
  },
  //privacy
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('@/views/settings/privacy-preview.vue'),
    meta: {
      layout: 'blank'
    },
  },
  //terms
  {
    path: '/terms-and-conditions',
    name: 'terms-and-conditions',
    component: () => import('@/views/settings/terms.vue'),
  },
  {
    path: '/terms',
    name: 'terms',
    component: () => import('@/views/settings/terms-preview.vue'),
    meta: {
      layout: 'blank'
    },
  },
  //////////////////////////pages//////////////////////////////////////
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/start-pages/Login.vue'),
    meta: {
      layout: 'blank'
    },
  },
  //ForgotPassword
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('@/views/ForgotPassword.vue'),
    meta: {
      layout: 'blank'
    },
  },
  {
    path: '/register',
    name: 'pages-register',
    component: () => import('@/views/start-pages/Register.vue'),
    meta: {
      layout: 'blank'
    },
  },
  {
    path: '/error-404',
    name: 'error-404',
    component: () => import('@/views/Error.vue'),
    meta: {
      layout: 'blank'
    },
  },
  {
    path: '*',
    redirect: 'error-404',
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

// array of routes that do not require auth
const plainRoutes = [
    "/",
    "/home",
    "/login",
    "/register",
    "/forgot-password",
    "/privacy",
    "/terms",
    "/error-404",
    "/error-500",
];

router.beforeEach((to, from, next) => {

    let to_path = to.path;
    // remove = from path
    if (to_path.includes("=")) {
        to_path = to_path.split("=")[0] + "=";
    }
    console.log(to_path);

    let isUserAuth = auth.isUserLoggedIn();
    let isPlainRoute = plainRoutes.includes(to_path);

    // If authenticated user visits login, register, /, or /home, redirect directly to their role home
    if (isUserAuth && (to_path === '/login' || to_path === '/register' || to_path === '/' || to_path === '/home')) {
        const userRole = auth.getUserRole ? auth.getUserRole() : 0;
        if (userRole === 5) {
            return next({ path: '/customer-service/tickets' });
        } else if (userRole === 4) {
            return next({ path: '/operations' });
        } else if (userRole === 3) {
            return next({ path: '/routes' });
        } else {
            return next({ path: '/dashboard' });
        }
    }

    //1 - if plain route, go to next
    if (isPlainRoute) {
        return next();
    }
    //2 - if not plain route and not auth, redirect to login
    if (!isUserAuth) {
        return next("/login");
    }

    const userRole = auth.getUserRole ? auth.getUserRole() : 0;

    // Block Activation page for internal dashboard staff roles (0, 3, 4, 5)
    const isActivationRoute = to_path === '/activate-account' || to_path === '/activation' || to.name === 'activate-account';
    if (isActivationRoute) {
        if (userRole === 5) {
            return next({ path: '/customer-service/tickets' });
        } else if (userRole === 4) {
            return next({ path: '/operations' });
        } else if (userRole === 3) {
            return next({ path: '/routes' });
        } else if (userRole === 0) {
            return next({ path: '/dashboard' });
        }
    }

    if (userRole === 5) {
        // Customer Service landing page: /customer-service/tickets
        if (to_path === '/dashboard' || to.name === 'dashboard' || to_path === '/' || to_path === '/home' || to_path === '/customer-service') {
            return next({ path: '/customer-service/tickets', query: to.query });
        }

        // Only approved screens for Customer Service in Phase 00.1: /customer-service, /users/view, error-404
        const isCustomerServiceAllowed =
            to_path.startsWith('/customer-service') ||
            to_path.startsWith('/users/view') ||
            to_path === '/error-404';

        if (!isCustomerServiceAllowed) {
            return next({ path: '/customer-service/tickets', query: to.query });
        }
    }

    if (userRole === 3) {
        // Route Making landing page: /routes
        if (to_path === '/dashboard' || to.name === 'dashboard' || to_path === '/' || to_path === '/home') {
            return next({ path: '/routes', query: to.query });
        }

        // Only approved screens for Route Making
        const isRouteMakingAllowed =
            to_path.startsWith('/routes') ||
            to_path.startsWith('/system-setup/routes') ||
            to_path.startsWith('/trips') ||
            to_path.startsWith('/trip-groups') ||
            to_path.startsWith('/users/view') ||
            to_path === '/error-404';

        if (!isRouteMakingAllowed) {
            return next({ path: '/routes', query: to.query });
        }
    }

    if (userRole === 4) {
        // Operations landing page: /operations
        if (to_path === '/dashboard' || to.name === 'dashboard' || to_path === '/' || to_path === '/home' || to_path === '/operations/home') {
            return next({ path: '/operations', query: to.query });
        }

        // Only approved screens for Operations in Phase 01: /operations
        const isOperationsAllowed =
            to_path.startsWith('/operations') ||
            to_path.startsWith('/users/view') ||
            to_path === '/error-404';

        if (!isOperationsAllowed) {
            return next({ path: '/operations', query: to.query });
        }
    }

    return next()
})

router.onError((error) => {
    if (/loading chunk \d+ failed/i.test(error.message) || /Loading CSS chunk/i.test(error.message)) {
        window.location.reload();
    }
});

export default router
